(function () {
  'use strict';

  function money(value) {
    var n = parseFloat(value);
    if (isNaN(n) || n <= 0) return null;
    // Whole dollars stay clean ($649); anything with cents shows two places ($99.90).
    var digits = n % 1 === 0 ? 0 : 2;
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: digits,
      maximumFractionDigits: digits
    }).format(n);
  }

  function render(el) {
    if (el.dataset.fsDone === '1') return;

    // Manual override wins, otherwise the per-product average
    var amount = money(el.dataset.override) || money(el.dataset.fallback);
    if (!amount) return;                 // nothing set — stays "FREE SHIPPING"

    var was = el.querySelector('.free-ship__was');
    if (!was) return;

    was.textContent = amount;
    el.dataset.fsDone = '1';
  }

  function init() {
    document.querySelectorAll('.free-ship').forEach(render);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when the cart drawer or a variant swap re-renders the markup
  document.addEventListener('shopify:section:load', init);
})();